import { FrenchCompany } from '@modules-deprecated/app/companies/types'

const frenchPublicEntityPrefixes = ['2', '7']

export const isFrenchPublicCompany = (company: Partial<FrenchCompany>): boolean =>
  frenchPublicEntityPrefixes.some((prefix: string) => company.legalFormCode?.startsWith(prefix))
